import { render, staticRenderFns } from "./NewUserRegistration.vue?vue&type=template&id=7b660b70&scoped=true"
import script from "./NewUserRegistration.vue?vue&type=script&lang=js"
export * from "./NewUserRegistration.vue?vue&type=script&lang=js"
import style0 from "./NewUserRegistration.vue?vue&type=style&index=0&id=7b660b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b660b70",
  null
  
)

export default component.exports